import { RefreshCw } from 'lucide-react';

interface ScrubberStats {
  contacts_processed: number;
  messages_sent: number;
  landlines_removed: number;
  tcpa_removed: number;
}

interface ListScrubberStatsProps {
  stats: ScrubberStats;
  loading?: boolean;
  error?: string | null;
}

/**
 * List Scrubber Statistics box
 * 2x2 grid showing key metrics for the selected date range
 */
export function ListScrubberStats({ stats, loading, error }: ListScrubberStatsProps) {
  const formatNumber = (num: number) => {
    return num.toLocaleString();
  };

  if (loading) {
    return (
      <div className="border-2 border-gray-300 rounded-lg overflow-hidden">
        <div className="bg-gray-800 text-white px-5 py-3">
          <span className="font-bold text-sm">List Scrubber Statistics</span>
          <span className="text-gray-400 text-xs ml-2">(for selected date range)</span>
        </div>
        <div className="flex items-center justify-center py-12 bg-gray-50">
          <RefreshCw className="w-6 h-6 animate-spin text-gray-400" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="border-2 border-gray-300 rounded-lg overflow-hidden">
        <div className="bg-gray-800 text-white px-5 py-3">
          <span className="font-bold text-sm">List Scrubber Statistics</span>
          <span className="text-gray-400 text-xs ml-2">(for selected date range)</span>
        </div>
        <div className="p-4 bg-gray-50">
          <p className="text-red-600 text-sm">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="border-2 border-gray-300 rounded-lg overflow-hidden">
      {/* Header */}
      <div className="bg-gray-800 text-white px-5 py-3">
        <span className="font-bold text-sm">List Scrubber Statistics</span>
        <span className="text-gray-400 text-xs ml-2">(for selected date range)</span>
      </div>

      {/* 2x2 Grid */}
      <div className="grid grid-cols-2">
        {/* Contacts Processed */}
        <div className="px-5 py-4 border-r border-b border-gray-200 bg-gray-50">
          <p className="text-xs text-gray-500 mb-1">Contacts Processed</p>
          <p className="text-2xl font-bold text-gray-900">{formatNumber(stats.contacts_processed)}</p>
        </div>

        {/* Messages Sent */}
        <div className="px-5 py-4 border-b border-gray-200 bg-gray-50">
          <p className="text-xs text-gray-500 mb-1">Messages Sent</p>
          <p className="text-2xl font-bold text-green-600">{formatNumber(stats.messages_sent)}</p>
        </div>

        {/* Landlines Removed */}
        <div className="px-5 py-4 border-r border-gray-200 bg-gray-50">
          <p className="text-xs text-gray-500 mb-1">Landlines Removed</p>
          <p className="text-2xl font-bold text-red-500">{formatNumber(stats.landlines_removed)}</p>
        </div>

        {/* TCPA Issues Removed */}
        <div className="px-5 py-4 bg-gray-50">
          <p className="text-xs text-gray-500 mb-1">TCPA Issues Removed</p>
          <p className="text-2xl font-bold text-red-500">{formatNumber(stats.tcpa_removed)}</p>
        </div>
      </div>
    </div>
  );
}
